import { usePainPartsRecoil } from '#pages/DashboardChartForm/states/painPartsState';
import { useState } from 'react';
import styled from 'styled-components';
import { AddPainPartModal } from './AddPainPartModal';
import { Item, Key } from './styles';

export const MemberInfoPainParts = () => {
  // 통증 추가 모달 표시여부
  const [isOpen, setIsOpen] = useState(false);

  // 추가할 통증 부위 리스트
  const { painParts } = usePainPartsRecoil();

  const onAddPainPart = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Item
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: ' center'
        }}
      >
        <Key>통증 (부위/정도)</Key>

        <div className="flex flex-col gap-8">
          {painParts.map((painPart, index) => (
            <div className="flex items-center justify-end gap-8">
              <div
                style={{
                  display: 'flex',
                  width: '20px',
                  height: '20px',
                  padding: '4px 8px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px',
                  borderRadius: '4px',
                  background: 'var(--bg-500, #373245)'
                }}
              >
                <div
                  style={{
                    color: 'var(--Gray-Scale-500, #948F9E)',
                    textAlign: 'center',
                    fontFamily: '"Pretendard Variable"',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px'
                  }}
                >
                  {index + 1}
                </div>
              </div>
              <PainPart key={painPart.kindId}>
                {painPart.name}/{painPart.level}
              </PainPart>
            </div>
          ))}

          <div
            onClick={onAddPainPart}
            className="h-[37px] pl-12 pr-16 py-8 bg-[#2e2a3a] rounded-lg justify-center items-center inline-flex"
          >
            <div className="text-[#bcb8c3] text-base font-normal font-['Pretendard Variable'] flex gap-2 items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <path
                  d="M7.3335 9.16683H3.3335V7.8335H7.3335V3.8335H8.66683V7.8335H12.6668V9.16683H8.66683V13.1668H7.3335V9.16683Z"
                  fill="#BCB8C4"
                />
              </svg>
              추가
            </div>
          </div>
        </div>
      </Item>

      <AddPainPartModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

const PainPart = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 8px;
  background: var(--bg-600, #2e2a3a);

  color: var(--Gray-Scale-300, #d7d3de);

  /* NEW/body_02_regular */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;
